//서브 페이지로 이동할 옷들 데이터

// id = 인덱스

let top_seller = [
    {
        // 여자옷
        id: 0, 
        imgUrl:"top_seller1.jpg",
        imgUrl2:"top_seller1_1.jpg",
        title: "말본 골프 스웨터 OFF WHITE",
        code:"M3122PKT15OWT",
        price:"339,000",

        subImgProd1:"01_topseller1.jpg",
        subImgProd2:"01_topseller2.jpg",
        subImgProd3:"01_topseller3.jpg",
        subImgProd4:"01_topseller4.jpg",
        subImgProd5:"01_topseller5.jpg"

    },{

        id: 1,
        imgUrl:"top_seller2.jpg",
        imgUrl2:"top_seller2_2.jpg",
        title: "우들리 카라 스웨터 CREAM",
        code:"M3122PKT17CRM",
        price:"359,000",

        subImgProd1:"02_topseller1.jpg",
        subImgProd2:"02_topseller2.jpg",
        subImgProd3:"02_topseller3.jpg",
        subImgProd4:"02_topseller4.jpg",
        subImgProd5:"02_topseller5.jpg"

    },{

        id: 2,
        imgUrl:"top_seller3.jpg",
        imgUrl2:"top_seller3_3.jpg",
        title: "버킷 포인트 폴로 티셔츠 GREEN",
        code:"M3222PTS34GRN",
        price:"259,000",

        subImgProd1:"03_topseller1.jpg",
        subImgProd2:"03_topseller2.jpg",
        subImgProd3:"03_topseller3.jpg",
        subImgProd4:"03_topseller4.jpg",
        subImgProd5:"03_topseller5.jpg"

    },{

        id: 3,
        imgUrl:"top_seller4.jpg",
        imgUrl2:"top_seller4_4.jpg",
        title: "블로우 스타디움 자켓 LIGHT BEIGE",
        code:"M3122PJK17BGL",
        price:"399,000",

        subImgProd1:"04_topseller1.jpg",
        subImgProd2:"04_topseller2.jpg",
        subImgProd3:"04_topseller3.jpg",
        subImgProd4:"04_topseller4.jpg",
        subImgProd5:"04_topseller5.jpg"

    },{
        //남자옷
        id: 4,
        imgUrl:"top_seller5.jpg",
        imgUrl2:"top_seller5_5.jpg",
        title: "버킷 폴로 포인트 티셔츠 LIGHT GRAY",
        code:"M3221PTS04LGR",
        price:"259,000",

        subImgProd1:"05_topseller1.jpg",
        subImgProd2:"05_topseller2.jpg",
        subImgProd3:"05_topseller3.jpg",
        subImgProd4:"05_topseller4.jpg",
        subImgProd5:"05_topseller5.jpg"

    },{

        id: 5,
        imgUrl:"top_seller6.jpg",
        imgUrl2:"top_seller6_6.jpg",
        title: "36 버킷 폴로 티셔츠 GREEN",
        code:"M3321PTS25GRN",
        price:"259,000",
        
        subImgProd1:"06_topseller1.jpg",
        subImgProd2:"06_topseller2.jpg",
        subImgProd3:"06_topseller3.jpg",
        subImgProd4:"06_topseller4.jpg",
        subImgProd5:"06_topseller5.jpg"

    },{

        id: 6,
        imgUrl:"top_seller7.jpg",
        imgUrl2:"top_seller7_7.jpg",
        title: "백 버킷 포인트 폴로 티셔츠 BLACK",
        code:"M3121PTS05BLK",
        price:"259,000",

        subImgProd1:"07_topseller1.jpg",
        subImgProd2:"07_topseller2.jpg",
        subImgProd3:"07_topseller3.jpg",
        subImgProd4:"07_topseller4.jpg",
        subImgProd5:"07_topseller5.jpg"

    },{

        id: 7,
        imgUrl:"top_seller8.jpg",
        imgUrl2:"top_seller8_8.jpg",
        title: "말본 컬러 블록 폴로 티셔츠 WHITE",
        code:"M3221PTS06WHT",
        price:"259,000",

        subImgProd1:"08_topseller1.jpg",
        subImgProd2:"08_topseller2.jpg",
        subImgProd3:"08_topseller3.jpg",
        subImgProd4:"08_topseller4.jpg",
        subImgProd5:"08_topseller5.jpg"

    },{ //모자 시작

        id: 8,
        imgUrl:"top_seller9.jpg",
        imgUrl2:"top_seller9_9.jpg",
        title: "말본 볼마커 & 바이저 SET GREEN",
        code:"M2341PVS02GRN",
        price:"119,000",

        subImgProd1:"09_topseller1.jpg",
        subImgProd2:"09_topseller2.jpg",
        subImgProd3:"09_topseller3.jpg",
        subImgProd4:"09_topseller4.jpg",
        subImgProd5:"09_topseller5.jpg"

    },{
        
        id: 9,
        imgUrl:"top_seller10.jpg",
        imgUrl2:"top_seller10_10.jpg",
        title: "빈티지 컬러 무드 캡 WHITE",
        code:"M3143PCP05WHT",
        price:"99,000",

        subImgProd1:"10_topseller1.jpg",
        subImgProd2:"10_topseller2.jpg",
        subImgProd3:"10_topseller3.jpg",
        subImgProd4:"10_topseller4.jpg",
        subImgProd5:"10_topseller5.jpg"

    },{

        id: 10,
        imgUrl:"top_seller11.jpg",
        imgUrl2:"top_seller11_11.jpg",
        title: "볼마커 바이저 SET IVORY",
        code:"M3142PVS12IVY",
        price:"129,000",

        subImgProd1:"11_topseller1.jpg",
        subImgProd2:"11_topseller2.jpg",
        subImgProd3:"11_topseller3.jpg",
        subImgProd4:"11_topseller4.jpg",
        subImgProd5:"11_topseller5.jpg"

    },

    {

        id: 11,
        imgUrl:"top_seller12.jpg",
        imgUrl2:"top_seller12_12.jpg",
        title: "빈티지 컬러 무드 캡 BLUE",
        code:"M3143PCP05BLU",
        price:"99,000",

        subImgProd1:"12_topseller1.jpg",
        subImgProd2:"12_topseller2.jpg",
        subImgProd3:"12_topseller3.jpg",
        subImgProd4:"12_topseller4.jpg",
        subImgProd5:"12_topseller5.jpg"

    }
]


export default top_seller 